// ---------- Time-range preset helper (used by multiple tabs) ----------------
//
// Moved verbatim out of aiUsageApi.ts. Pure — no I/O, no transport import.

export type TimeRangePreset =
  | 'today'
  | '7d'
  | '30d'
  | '90d'
  | 'this_month'
  | 'last_month'
  | 'ytd'
  | 'all_time'
  | 'custom';

export interface TimeRangeValue {
  preset: TimeRangePreset;
  fromIso?: string;
  toIso?: string;
}

export function resolveTimeRange(v: TimeRangeValue): { fromIso?: string; toIso?: string } {
  const now = new Date();
  const iso = (d: Date) => d.toISOString();
  const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  switch (v.preset) {
    case 'today':
      return { fromIso: iso(startOfDay(now)), toIso: iso(now) };
    case '7d':
      return { fromIso: iso(new Date(now.getTime() - 7 * 86400000)), toIso: iso(now) };
    case '30d':
      return { fromIso: iso(new Date(now.getTime() - 30 * 86400000)), toIso: iso(now) };
    case '90d':
      return { fromIso: iso(new Date(now.getTime() - 90 * 86400000)), toIso: iso(now) };
    case 'this_month': {
      const from = new Date(now.getFullYear(), now.getMonth(), 1);
      return { fromIso: iso(from), toIso: iso(now) };
    }
    case 'last_month': {
      const from = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const to = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59);
      return { fromIso: iso(from), toIso: iso(to) };
    }
    case 'ytd': {
      const from = new Date(now.getFullYear(), 0, 1);
      return { fromIso: iso(from), toIso: iso(now) };
    }
    case 'all_time':
      // True all-time: an early lower bound so endpoints that default an
      // absent `from` to "last 30 days" don't silently narrow the window.
      return { fromIso: '2020-01-01T00:00:00.000Z', toIso: iso(now) };
    case 'custom':
      return { fromIso: v.fromIso, toIso: v.toIso };
    default:
      return {};
  }
}
